import { createContext } from "react";

const EventModualContext = createContext({});

export default EventModualContext;
